import { getMentionLinkMarkdown } from '#pplx/frontend/composer-sdk/lexical/utils/getMentionLinkMarkdown.js';
export const EMPTY_PREFILL_SUBMISSION_CONTEXT = { prefills: [] };
export function mkSkillPrefills(skillNames) {
    return skillNames.map((value) => ({ type: 'skill', value }));
}
export function dedupePrefills(prefills) {
    const seen = new Set();
    return prefills.filter((prefill) => {
        const key = `${prefill.type}:${prefill.value}`;
        if (seen.has(key))
            return false;
        seen.add(key);
        return true;
    });
}
export function isPrefillMention(props) {
    return props.variant === 'skills' || props.variant === 'plugin';
}
export function serializePrefillMention(props) {
    // The thread shows the localized label; the prefill keeps the canonical value the backend resolves.
    const displayLabel = props.localizedName || props.text;
    return {
        text: getMentionLinkMarkdown(displayLabel, props.url) ?? displayLabel,
        mention: { id: props.uuid, url: '', type: props.variant },
        prefill: props.variant === 'skills'
            ? { type: 'skill', value: props.text }
            : { type: 'plugin', value: props.uuid },
    };
}
export function buildPrefillSubmissionContext(prefills) {
    return { prefills: dedupePrefills(prefills) };
}
/** Explicit values win over derived ones; an explicit empty array is an intentional override. */
export function resolvePrefillSubmissionContext(derived, explicit) {
    return { prefills: explicit.prefills === undefined ? derived.prefills : [...explicit.prefills] };
}
//# sourceMappingURL=prefills.js.map